import { getAppStore } from '~src/app/AppStore';
import { nonSystemJobFilter } from '~src/backgroundJob/types/IBackgroundJob';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';
import { NavLocationSelectors } from '~src/spacesPlatform/selectors/NavigationStateSelectors';
import { FilterMap } from '~src/spacesPlatform/state/ContentExplorerState';
import { NullProjectIdForNonProjects } from '~src/spacesPlatform/state/SpaceInfo';
import { Filter } from '~src/ts/helpers/Filter';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { FilterFieldNames } from '~src/ts/ServerApi/types/IFilterClause';

// TODO: Refactor this with SpaceInfo
export function getGenericDefaultFilters(projectId: string) {
  let filterMap: FilterMap = {};
  if (projectId !== NullProjectIdForNonProjects) {
    filterMap[ContentFiltersKeys.project] = ServerFilterClauses.create({ project: projectId })[0];
  }
  return filterMap;
}

export function getNoDefaultFilters(_projectId: string) {
  return {};
}

export function getDataSourceDefaultFilters(projectId: string) {
  let filterMap: FilterMap = getGenericDefaultFilters(projectId);
  filterMap[ContentFiltersKeys.showEmbedded] = ServerFilterClauses.serverFilterClauses[ContentFiltersKeys.showEmbedded]('false');
  return filterMap;
}

export function getDataConnectionDefaultFilters(projectId: string): FilterMap {
  let filterMap: FilterMap = getDataSourceDefaultFilters(projectId);

  // Since, in the current UX, data connections are listed under the data sources tab,
  // data connections should always be filtered to those contained by a data source
  // (not those contained by a flow), whether flows are enabled or not.
  filterMap[ContentFiltersKeys.containerType] = ServerFilterClauses.create({containerType: 'datasource'})[0];

  return filterMap;
}

export function getBackgroundJobsDefaultFilters(projectId: string) {
  const sessionManagementService = getSessionManagementServiceInstance();
  const isServerPage = NavLocationSelectors.inServerArea(getAppStore().getState());

  return {
    backgroundJobTaskType: nonSystemJobFilter,
    siteId: isServerPage ? undefined : Filter.stringFieldEq(FilterFieldNames.siteId, sessionManagementService.sessionSiteId())
  };
}
